import React, { useEffect, useState } from 'react';
import { Box, IconButton, TextField } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { trackAnalyticsEvent } from '../../../utils/clevertap/clevertapUtils';

const AddRemoveQtyButton = ({
  onIncreasePress = () => {},
  onReducePress = () => {},
  onTextChange = () => {},
  quantity = 0,
  textStyles = {},
  productId = null,
  productName = null,
}) => {
  const [enteredQty, setEnteredQty] = useState(Number(quantity));

  useEffect(() => {
    setEnteredQty(Number(quantity));
  }, [quantity]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    // Allow only numeric input
    if (/^\d*$/.test(value)) {
      // Track manual quantity input
      trackAnalyticsEvent('PRODUCT_QUANTITY_MANUAL_INPUT', {
        product_id: productId,
        product_name: productName,
        old_quantity: enteredQty,
        new_quantity: value,
        input_method: 'text_input',
        action: 'quantity_text_change'
      });
      onTextChange(value);
    }
  };

  return (
    <Box
      sx={{
        width: 'fit-content',
        display: 'flex',
        alignItems: {xs: 'center', md: 'center'},
        border: '1px solid #D9D9D9',
        px: 0.5,
        borderRadius: '0.5rem',
        order: {xs: 2, md: 1},

      }}
    >
      <IconButton
        onClick={() => {
          // Track quantity decrease
          trackAnalyticsEvent('PRODUCT_QUANTITY_DECREASED', {
            product_id: productId,
            product_name: productName,
            previous_quantity: quantity,
            action: 'quantity_decrease_button'
          });
          onReducePress();
        }}
        size='small'
      >
        <Remove 
          fontSize='small'
        />
      </IconButton>

      <TextField
        value={enteredQty}
        onChange={handleInputChange}
        sx={{
          p: 0,
          width: '2rem',
          border: 'none',
          '& .MuiInputBase-input': {
            paddingBottom: '0px',
          },
        }}
        InputProps={{
          disableUnderline: true,
        }}
        inputProps={{
          style: { textAlign: 'center', ...textStyles },
          disableUnderline: true,
        }}
        variant='standard'
        size='small'
      />

      <IconButton
        onClick={() => {
          // Track quantity increase
          trackAnalyticsEvent('PRODUCT_QUANTITY_INCREASED', {
            product_id: productId,
            product_name: productName,
            previous_quantity: quantity,
            action: 'quantity_increase_button'
          });
          onIncreasePress();
        }}
        size='small'
      >
        <Add
          fontSize='small'
        />
      </IconButton>
    </Box>
  );
};

export default AddRemoveQtyButton;
